import { AlertTriangle, Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";

export function Loading({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div role="status" className="flex items-center gap-2 p-4 text-sm text-muted-foreground">
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      {label ?? t("states.loading")}
    </div>
  );
}

export function ErrorState({ title, error, onRetry }: { title: string; error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="space-y-2 rounded-lg border border-negative/40 bg-negative/5 p-4 text-sm">
      <p className="flex items-center gap-2 font-medium text-negative">
        <AlertTriangle className="h-4 w-4" aria-hidden />
        {title}
      </p>
      {error instanceof Error ? <p className="text-muted-foreground">{error.message}</p> : null}
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t("states.retry")}
        </Button>
      ) : null}
    </div>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <p className="p-4 text-sm text-muted-foreground">{children}</p>;
}
